import { createFileRoute, redirect } from "@tanstack/react-router";

import { hasPermission } from "@/modules/auth/lib/permissions";
import { ClientMaterialsListPage } from "@/modules/stock/pages/ClientMaterialsList.page";

export const Route = createFileRoute("/__authed/m/stock/customer-materials")({
	beforeLoad({ context }) {
		const user = "user" in context ? context.user : undefined;

		if (!hasPermission(user, "see_client_materials")) {
			throw redirect({ to: "/m/dashboard" });
		}
	},
	component: ClientMaterialsListPage,
});
